/**
 * OrangeHRM Telegram Plugin pages
 */
import TelegramIntegration from './pages/TelegramIntegration.vue';
import TelegramConfig from './pages/TelegramConfig.vue';

export default {
  'telegram-integration': TelegramIntegration,
  'telegram-config': TelegramConfig,
};
